"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalListItem = exports.LegalList = exports.LegalContent = exports.ListItem = exports.List = exports.StyledContent = exports.MenuCloseWrapper = exports.MenuOverlay = exports.MenuContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.MenuContainer = styled_components_1.default.div `
  position: relative;

  display: flex;
  align-items: center;
  height: 100%;
`;
exports.MenuOverlay = styled_components_1.default.div `
  position: fixed;
  z-index: 7;
  top: 0;
  left: 0;

  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  width: 100%;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    display: none;
  }
`;
exports.MenuCloseWrapper = styled_components_1.default.div `
  position: absolute;
  top: ${({ theme }) => theme.space.s300};
  right: ${({ theme }) => theme.space.s300};

  width: 16px;
  height: 16px;

  cursor: pointer;

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    display: none;
  }
`;
const contentTransition = (0, styled_components_1.css) `
  &.header--menu-enter {
    left: -293px;
  }

  &.header--menu-enter-active {
    left: 0;

    transition: left ease-in-out 150ms;
  }

  &.header--menu-exit {
    left: 0;
  }

  &.header--menu-exit-active {
    left: -293px;

    transition: left ease-in-out 150ms;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    &.header--menu-enter {
      left: 0;

      opacity: 0;
    }

    &.header--menu-enter-active {
      left: 0;

      opacity: 1;
      transition: opacity ease-in-out 200ms;
    }

    &.header--menu-exit {
      left: 0;

      opacity: 1;
    }

    &.header--menu-exit-active {
      left: 0;

      opacity: 0;
      transition: opacity ease-in-out 200ms;
    }
  }
`;
exports.StyledContent = styled_components_1.default.div `
  position: fixed;
  z-index: 9;
  top: 0;
  left: 0;

  display: block;
  overflow-y: scroll;
  width: 293px;
  height: 100%;
  padding: ${({ theme }) => theme.space.s600} ${({ theme }) => theme.space.s300};
  border-right: 1px solid ${({ theme }) => theme.colors.gray.s300};

  background-color: ${({ theme }) => theme.colors.white.s100};

  text-align: left;

  border-radius: 0;

  ${contentTransition};

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    position: absolute;
    top: 100%;

    overflow-y: inherit;
    width: inherit;
    min-width: 220px;
    height: auto;
    padding: 0 ${({ theme }) => theme.space.s300};
    border: 1px solid ${({ theme }) => theme.colors.gray.s300};

    border-radius: ${({ theme }) => theme.radius.s100};
    transition: all 150ms;

    ::after,
    ::before {
      content: '';

      position: absolute;
      left: ${({ theme }) => theme.space.s150};

      height: 10px;
      border: 5px solid transparent;
      border-top: none;
    }

    ::after {
      top: -10px;

      border-bottom-color: ${({ theme }) => theme.colors.white.s100};
    }

    ::before {
      top: -11px;

      border-bottom-color: ${({ theme }) => theme.colors.gray.s300};
    }
  }
`;
exports.List = styled_components_1.default.ul `
  padding: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.gray.s300};
  margin: 0;

  :nth-child(2) {
    border-top: 0;
  }
`;
exports.ListItem = styled_components_1.default.li `
  display: flex;
  padding: ${({ theme }) => theme.space.s100} 0 ${({ theme }) => theme.space.s100};

  font-size: inherit;

  list-style: none;

  :first-child {
    padding-top: ${({ theme }) => theme.space.s300};
  }

  :last-child {
    padding-bottom: ${({ theme }) => theme.space.s300};
  }

  & a:hover {
    & svg path {
      fill: ${({ theme }) => theme.colors.main.base};
    }
  }

  a {
    white-space: break-spaces;
    display: flex;
    align-items: center;

    ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.regularTextMain)};
  }

  span {
    flex: 1;
  }

  svg {
    display: inline-block;
    margin-right: ${({ theme }) => theme.space.s100};

    font-size: 1.75rem;

    vertical-align: -0.5rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    :first-child {
      padding-top: ${({ theme }) => theme.space.s200};
    }

    :last-child {
      padding-bottom: ${({ theme }) => theme.space.s200};
    }
  }
`;
exports.LegalContent = styled_components_1.default.div `
  padding-top: ${({ theme }) => theme.space.s050};
`;
exports.LegalList = (0, styled_components_1.default)(exports.List) `
  padding-bottom: ${({ theme }) => theme.space.s300};
  border: none;
`;
exports.LegalListItem = styled_components_1.default.li `
  padding-top: ${({ theme }) => theme.space.s150};

  list-style: none;

  a {
    color: ${({ theme }) => theme.colors.gray.s500};

    ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.regularTextMain)};

    :hover {
      cursor: pointer;
    }
  }
`;
